<div class="quarterly-feedback-container">
  <emerald-tab-bar [tabsData]="tabsData" class="custom-green" [showContent]="true"
                   (selectedTabChange)="onTabChange($event)"></emerald-tab-bar>

  <div *ngIf="(selectedTab?.label ?? '') === tabLabels.Compliance">
    <div class="compliance-section">
      <div class="rto-compliance-card">
        <h3>{{ VendorProfile.rtoCompliance }}</h3>
        <app-rto-bar-chart></app-rto-bar-chart>
        <div class="legend">
          <span class="compliant-dot"></span> {{ rtoConstants.barChartLabelCompliant }}
          <span class="non-compliant-dot"></span> {{ rtoConstants.barChartLabelNonCompliant }}
        </div>
      </div>
      <div class="general-compliance-card">
        <div class="header">
          <h3>{{ VendorProfile.generalCompliance }}</h3>

          <div class="filter">
            <emerald-dropdown [options]="monthOptions" [outlined]="true" [id]="'single_select'" [label]="'Month'"
                              (onChange)="onMonthChange($event)"></emerald-dropdown>
          </div>
        </div>
        <div class="items-container">
          <div class="item" *ngFor="let item of generalCompliance">
            <div class="label-row">
              <span class="label">{{ item.label }}</span>
              <a [href]="item.fileUrl" download>
                <img class="logo" src="../../../../../assets/icons/excel.svg" alt="Download Excel" />
              </a>
            </div>
            <span class="value" [class.red]="item.highlight">{{ item.value }}</span>
          </div>
        </div>
      </div>
      <div class="spacer"></div>
    </div>
  </div>
  <div *ngIf="(selectedTab?.label ?? '') === tabLabels.PeopleMetrics">
    <div class="placeholder-tab-content">
      <app-people-metrics></app-people-metrics>
    </div>
  </div>
  <div *ngIf="(selectedTab?.label ?? '') === tabLabels.LearningDevelopment">
    <div class="placeholder-tab-content">Feedback details coming soon...</div>
  </div>
  <div *ngIf="(selectedTab?.label ?? '') === tabLabels.StrategicPartnership">
    <div class="placeholder-tab-content">Other information coming soon...</div>
  </div>
</div>
